import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/index.css";
import axios from "../../../axios";
import { toast } from "react-toastify";
import { Clock3, ExternalLink, Globe, Hand, X } from "lucide-react";

/**
 * Shows the join now event on day view
 * @param {} param0
 * @returns
 */
//Pending work here I have implemented the join now feature by taking reference from documentaion but it is not verified because I am not getting the bbb lecture id in events.
const TimeTableJoinNow = ({ event, obj, fromHomePage }) => {
  const navigate = useNavigate();
  let _id;

  const userData = JSON.parse(localStorage.getItem("breathForStudent"));

  const [joinNow, setJoinNow] = useState(false);
  const [boradCastLink, setBoradCastLink] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showModalInstruction, setShowModalInstruction] = useState(false);
  useEffect(() => {
    event?.Events?.forEach((element) => {
      if (element?.name === "bbb_lecture") {
        setJoinNow(true);
      }
    });
  }, [event]);
  const foundItem = event?.Events?.find((item) => item.name === "bbb_lecture");
  const onJoinNowClick = async (e) => {
    e.stopPropagation();
    setIsLoading(true);
    const data = JSON.parse(localStorage.getItem("breathForStudent"));
    if (fromHomePage === "fromHomePage") {
      if (obj.supplements) {
        _id = obj?.supplements?.bbb_lecture;
        setJoinNow(true);
      }
    } else {
      event.Events.forEach((element) => {
        if (element.name === "bbb_lecture") {
          setJoinNow(true);
          _id = element?.value;
        }
      });
    }

    try {
      if (userData?.school?.liveClassType === "broadcast") {
        const response = await axios.get(
          `/videoConference/classes/join/${_id}?viewer_name=${data?.name}&user_id=${userData?.id}&school_id=${userData?.school?.id}`,
        );
        if (response.data.data) {
          setBoradCastLink(response.data.data);
          setShowModal(true);
        }
      } else {
        const res = await axios.get(
          `/videoConference/classes/join/${_id}?viewer_name=${data?.name}&user_id=${userData?.id}&school_id=${userData?.school?.id}`,
        );
        if (res.data.data) {
          const win = window.open(res.data.data, "_blank");
          if (win) win.focus();
        }
      }
    } catch (error) {
      console.error("Join class error:", error);
      toast.error("Meeting is not started!!");
    } finally {
      setIsLoading(false);
      setShowModalInstruction(false);
    }
  };

  return obj?.supplements || event?.Events[0] !== "Planner" ? (
    <>
      {(event?.Events?.length > 0 || obj?.supplements) && (
        <div className="summary_con col mt-1">
          <button
            className="Join_button"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setShowModalInstruction(true);
            }}
          >
            <div>
              <p
                style={{
                  backgroundColor: isLoading ? "#e0e0e0" : "#fff",
                  color: "#4169e1",
                  border: `${obj?.supplements ? "1px solid #4169e1" : "2px solid #4169e1"}`,
                  borderRadius: "50px",
                  fontSize: "13px",
                  letterSpacing: "0.5px",
                  transition: "all 0.3s ease",
                  cursor: isLoading ? "not-allowed" : "pointer",
                  opacity: isLoading ? 0.6 : 1,
                  padding: "4px 5px",
                }}
              >
                {" "}
                {"Join Now"}
              </p>
            </div>
          </button>
        </div>
      )}
      {showModal && (
        <div className="ContainerSubmitedSucess2 ">
          <div className="SubContainerSubmitedSucessBoradcast">
            <div className="flex justify-between items-center">
              <h4 className="text-blue-950 font-semibold">Online Session</h4>
              <div className="mb-2 cursor-pointer">
                <X
                  color="black"
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowModal(false);
                  }}
                />
              </div>
            </div>
            <div>
              <iframe
                src={boradCastLink}
                width="900"
                height="500"
                frameBorder="0"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      )}
      {showModalInstruction && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
          <div className="w-full max-w-lg rounded-3xl bg-white p-4 shadow-2xl animate-in fade-in zoom-in duration-200">
            {/* Title */}
            <h2 className="mt-5 text-center text-3xl font-bold text-gray-800">
              💻 Live Class
            </h2>

            {/* Description */}
            <p className="mt-3 text-center text-gray-600">
              The Live Class will open in your browser.
            </p>

            {/* Info Box */}
            <div className="mt-6 rounded-xl bg-gray-100 p-4 space-y-4">
              <div className="flex items-start gap-3">
                <Clock3 className="mt-1 h-5 w-5 text-orange-500" />
                <p className="text-sm text-gray-700">
                  On slow networks, it may take up to <b>2 minutes.</b>
                </p>
              </div>

              <div className="flex items-start gap-3">
                <Hand className="mt-1 h-5 w-5 text-red-500" />
                <p className="text-sm text-gray-700">
                  Please wait and avoid tapping <b>Join</b> again.
                </p>
              </div>

              <div className="flex items-start gap-3">
                <Globe className="mt-1 h-5 w-5 text-blue-500" />
                <p className="text-sm text-gray-700 w-70">
                  If you retry later, close any previously opened Live <br/> Class
                  browser tab.
                </p>
              </div>
            </div>

            {/* Button */}
            <div className="flex items-center justify-between gap-3">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setShowModalInstruction(false);
                }}
                className="mt-7 w-full rounded-full bg-orange-400 py-3 font-semibold text-white transition hover:bg-orange-300"
              >
                Close
              </button>
              <button
                onClick={(e) => {
                  if (isLoading) return;
                  setIsLoading(true);
                  onJoinNowClick(e);
                  setIsLoading(false);
                }}
                className="mt-7 w-full rounded-full bg-purple-100 py-3 font-semibold text-purple-700 transition hover:bg-purple-200"
              >
                {isLoading ? "Joining..." : "Continue"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  ) : null;
};

export default TimeTableJoinNow;
